export default class ScrollToTop {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.bindEvents()
  }

  bindEvents() {
    if(this.el) {
      this.el.addEventListener('click', e => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      })
    }
  }
}
